import { NavLink, useLocation } from 'react-router-dom'
import { twJoin } from 'tailwind-merge'

import { useAppContext } from '@/app/index.context'

import { useNavBarForCustomer } from './useNavBarForCustomer'

import './nav-bar.scss'

export const NavBar = () => {
  const { whiteLabel } = useAppContext()
  const { pathname } = useLocation()

  const routes = useNavBarForCustomer()

  if (!routes) throw new Error('No routes found for NavBar!')

  const selectedRoute = routes.find(item =>
    item.route === '/' ? pathname === '/' : pathname.includes(item.route)
  )

  return (
    <nav className={`nav-bar ${whiteLabel}`}>
      <div className="primary">
        <ul>
          {routes.map(nav => (
            <li key={`primary-${nav.route}`}>
              <NavLink
                to={nav.defaultRoute || nav.route}
                className={({ isActive }) =>
                  twJoin(
                    isActive && whiteLabel === 'threeStepIT' && 'bg-threeStepIT-beige',
                    isActive && whiteLabel !== 'threeStepIT' && 'bg-zinc-700'
                  )
                }
              >
                {Boolean(nav.Icon) && nav.Icon}
                {nav.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>

      <div className={twJoin('secondary', selectedRoute?.subRoutes?.length === 0 && 'hidden')}>
        <ul>
          {selectedRoute?.subRoutes?.map(nav => (
            <li key={nav.route}>
              <NavLink
                end
                to={nav.route}
                className={({ isActive }) =>
                  twJoin(
                    isActive && whiteLabel === 'threeStepIT' && 'bg-threeStepIT-beige',
                    isActive && whiteLabel !== 'threeStepIT' && 'bg-zinc-300'
                  )
                }
              >
                {Boolean(nav.Icon) && nav.Icon}
                {nav.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  )
}
